"use client"

import React, { ReactNode } from "react"
import styled from "styled-components"
import { StyledComponentsProvider } from "@motorata/base-ui.providers.styled-components";
import { BaseStyles } from "@motorata/base-ui.types.base-styles";
import { Box, common } from "@motorata/base-ui.components.atoms._atoms";
import Footer from "../layout/Footer";
import Header from "../layout/Header";
import StyledComponentsRegistry from "@/lib/registry";
import AccountProvider from "@/providers/AccountProvider";
import SearchProvider from "@/providers/SearchProvider";

const MainView = ({
  children,
  ...rest
}: {
  children: ReactNode
}) => {
  return (
    <>
      <StyledComponentsRegistry>
        <StyledComponentsProvider>
          <SearchProvider>
            <AccountProvider>
              <Wrapper className="page_wrapper">
                <Header />
                <Content {...rest}>{children}</Content>
                <Footer />
              </Wrapper>
            </AccountProvider>
          </SearchProvider>
        </StyledComponentsProvider>
      </StyledComponentsRegistry>
    </>
  )
}

export default MainView

const Wrapper = styled(Box)<BaseStyles>`
  ${common};
`

const Content = styled(Box)<BaseStyles>`
  ${common};
  padding-top: ${({ theme }) => theme.space.XXL};
  width: ${({ width }) => width ?? "90%"};
  margin: 0 auto;
  
  @media (max-width: 800px){
    padding-top: ${({ theme }) => theme.space.XL};
  }

  .background {
    > * {
      position: relative;
    }

    &::before {
      display: block;
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100%;
      margin-left: calc((100vw - 100%) / -2);
      background: ${({ theme }) => theme.color.background};
      z-index: 0;
    }
  }

  .background_white {
    > * {
      position: relative;
    }

    &::before {
      display: block;
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100%;
      margin-left: calc((100vw - 100%) / -2);
      background: ${({ theme }) => theme.color.white};
      z-index: 0;
    }
  }
`
